import { isBefore, isAfter, parseISO } from 'date-fns';
export const endDateIsBeforeStart = ({ t, params: input }) => (value, allValues) => {
    const { startDateFieldName, endDateFieldName } = input;
    if (allValues[startDateFieldName] && allValues[endDateFieldName]) {
        return isBefore(parseISO(allValues[endDateFieldName]), parseISO(allValues[startDateFieldName]))
            ? t('common:validators:dates:end_date_must_be_before_start_date')
            : undefined;
    }
    return t('common:validators:format:input_not_valid');
};
export const endDateIsAfterStart = ({ t, params: input }) => (value, allValues) => {
    const { startDateFieldName, endDateFieldName } = input;
    if (allValues[startDateFieldName] && allValues[endDateFieldName]) {
        return isAfter(parseISO(allValues[endDateFieldName]), parseISO(allValues[startDateFieldName]))
            ? t('common:validators:dates:end_date_must_be_before_start_date')
            : undefined;
    }
    return t('common:validators:format:input_not_valid');
};
//# sourceMappingURL=validation.dates.js.map